import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import errorIcon from '../../../../../assets/images/club_product_v2/error-icon.svg';

const AddSubcategoryModal = ({
  show,
  onHide,
  onSave,
  parentCategories = [],
  editMode = false,
  initialData = null,
}) => {
  const [name, setName] = useState('');
  const [parentId, setParentId] = useState(parentCategories[0]?.id || '');
  const [addType, setAddType] = useState('link');
  const [link, setLink] = useState('');
  const [file, setFile] = useState('');
  const [uploadFileError, setUploadFileError] = useState('');
  const [existingFileName, setExistingFileName] = useState(null);

  useEffect(() => {
    if (editMode && initialData) {
      let extractedFileName = null;
      if (initialData.link_file && initialData.link_file instanceof File) {
        extractedFileName = initialData.link_file.name;
      } else if (initialData.link_file && initialData.link_file.url) {
        const linkUrl = initialData.link_file?.url;
        extractedFileName = new URL(linkUrl).pathname.split('/').pop();
      }
      setName(initialData.name || '');
      setParentId(initialData.parent_id?.toString() || parentCategories[0]?.id?.toString() || '');
      setAddType(initialData.link ? 'link' : 'upload');
      setLink(initialData.link || '');
      setFile('');
      setExistingFileName(initialData.file?.name || extractedFileName || null);
    } else {
      setName('');
      setParentId(parentCategories[0]?.id?.toString() || '');
      setAddType('link');
      setLink('');
      setFile('');
      setExistingFileName(null);
    }
  }, [editMode, initialData, parentCategories, show]);

  const handleFileUpload = (file) => {
    let message = '';

    if (file.size > 10000000) {
      message = 'File exceeds maximum size.';
    }

    // if (!['image/jpeg', 'image/png', 'image/gif', 'image/bmp'].includes(file.type)) {
    //   message += ' File format should be jpg, jpeg, gif, png, bmp.';
    // }

    if (message !== '') {
      setUploadFileError(message);
      setFile('');
    } else {
      setUploadFileError('');
      setFile(file);
    }
  }

  const handleSave = () => {
    const data = {
      id: editMode && initialData ? initialData.id : undefined,
      name,
      parent_id: parentId,
      link: addType === 'link' ? link : '',
      file: addType === 'upload' ? file : '',
      addType,
    };
    onSave(data);
    onHide();
  };

  const handleCopyLink = () => {
    const selectedParent = parentCategories.find(cat => cat.id.toString() === parentId.toString());
    if (selectedParent && selectedParent.link && selectedParent.link != '') {
      alert(window.I18n.t('mobile_app_dashboard.modals.copied_link'));
      navigator.clipboard.writeText(selectedParent.link);
    } else {
      alert(window.I18n.t('mobile_app_dashboard.modals.no_link_found'));
    }
  };

  const selectedParent = parentCategories.find(cat => cat.id.toString() === parentId.toString());
  const showWarning = !!(!editMode && selectedParent && (selectedParent.link != '' || selectedParent.link_file?.url || selectedParent.link_file?.name));

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        {editMode ? window.I18n.t('mobile_app_dashboard.modals.edit_submenu') : window.I18n.t('mobile_app_dashboard.modals.add_new_submenu')}
      </Modal.Header>
      <Modal.Body>
        <div className='form-row mb-3'>
          <div className='row'>
            <div className='col-sm-3 label_names'>
              <label>{window.I18n.t('mobile_app_dashboard.modals.name')}</label>
            </div>
            <div className='col-sm-9'>
              <input
                type="text"
                className="form-control"
                value={name}
                maxLength={60}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>
        </div>

        <hr />

        <div className='form-row mb-3'>
          <div className='row'>
            <div className='col-sm-3 label_names'>
              <label>{window.I18n.t('mobile_app_dashboard.modals.menu')}</label>
            </div>
            <div className='col-sm-9'>
              <select
                className='form-control'
                value={parentId}
                onChange={(e) => setParentId(e.target.value)}
              >
                {parentCategories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <hr />

        <div className='form-row'>
          <div className='row'>
            <div className='col-sm-3 label_names'>
              <label>{window.I18n.t('mobile_app_dashboard.modals.add')}</label>
            </div>
            <div className='col-sm-9'>
              <div>
                <div className='row link-row add-margin-bottom-5'>
                  <label className='icheck-label col-xs-3 col-sm-3 col-md-3 col-lg-3 link-label'>
                    <div className={`iradio_square-orange icheck-item ${addType === 'link' ? 'checked' : ''}`}>
                      <input
                        type='radio'
                        name='add_type'
                        value='link'
                        className='i-checks icheck-input'
                        checked={addType === 'link'}
                        onChange={() => setAddType('link')}
                      />
                    </div>
                    <span>{window.I18n.t('mobile_app_dashboard.modals.link')}</span>
                  </label>

                  <div className='col-xs-9 col-sm-9 col-md-9 col-lg-9'>
                    {addType === 'link' && (
                      <input
                        type='text'
                        className='form-control'
                        placeholder='Enter link'
                        value={link}
                        onChange={(e) => setLink(e.target.value)}
                      />
                    )}
                  </div>
                </div>

                <div className='row link-row'>
                  <label className='icheck-label link-label'>
                    <div className={`iradio_square-orange icheck-item ${addType === 'upload' ? 'checked' : ''}`}>
                      <input
                        type='radio'
                        name='add_type'
                        value='upload'
                        className='i-checks icheck-input'
                        checked={addType === 'upload'}
                        onChange={() => setAddType('upload')}
                      />
                    </div>
                    <span>{window.I18n.t('mobile_app_dashboard.modals.upload_file')}</span>
                  </label>
                </div>

                {addType === 'upload' && (
                  <>
                    <div className='row'>
                      <input
                        type='file'
                        className='add-padding-left-20'
                        onChange={(e) => handleFileUpload(e.target.files[0])}
                      />
                    </div>

                    {existingFileName && (
                      <div className="add-margin-top-10 add-padding-left-25 text-muted">
                        {window.I18n.t('mobile_app_dashboard.modals.current_file')}: <strong>{existingFileName}</strong>
                      </div>
                    )}

                    <div className='row help-message add-margin-left-10 add-margin-top-10'>
                      <div>{window.I18n.t('mobile_app_dashboard.modals.acceptable_file')}</div>
                    </div>
                  </>
                )}

                {uploadFileError && (
                  <div className='error-message btsp_alert_notices add-margin-bottom-10 add-padding-all-5'>
                    {uploadFileError}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {showWarning && (
          <div className="alert-warning-box">
            <img src={errorIcon} alt="Warning" />
            <div>
              {window.I18n.t('mobile_app_dashboard.modals.link_warning')}{' '}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleCopyLink();
                }}
              >
                {window.I18n.t('mobile_app_dashboard.modals.copy_link')}
              </a> {window.I18n.t('mobile_app_dashboard.modals.copy_link_attached')}
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>Close</Button>
        <Button
          className='btsp_orange_button'
          onClick={handleSave}
          disabled={!name || !parentId || (addType === 'link' && !link)}
        >
          {window.I18n.t('mobile_app_dashboard.modals.save')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddSubcategoryModal;
